import React, { useEffect, useState } from 'react';
import { Container, Typography, Button, Box, Card, CardMedia, Grid, useTheme, useMediaQuery, Paper, FormControlLabel, Checkbox } from '@mui/material';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import { useNavigate, useParams } from 'react-router-dom';
import logo from '../../images/0819db8c82d9cffc3dd22bd091848a1f.png'; // Altere o caminho da imagem se necessário
import { useDispatch, useSelector } from 'react-redux';
import { useSpring, animated } from 'react-spring';
import { consultarAssinatura, fetchOpcoesStart, fetchPlanosStart, salvarPlano, setPlanoEscolhido, trocarPlano } from '../../store/reducers/plano';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { CheckBoxOutlineBlankSharp, CheckBoxSharp } from '@mui/icons-material';
import { limparDadosAction, limparDadosEnvioPagamento, setarFreemium } from '../../store/reducers/utils';
import usePagination from '@mui/material/usePagination/usePagination';
function TrocarPlano() {
    const { planoID } = useParams();
    const { usuarioID } = useParams();
    const navigate = useNavigate();
    const planos = useSelector(state => state.plano.planos);
    const [planoSelecionado, setPlanoSelecionado] = useState({});
    const [opcaoSelecionada, setOpcaoSelecionada] = useState("");
    const [loading, setLoading] = useState(true);
    const { planoNome } = useParams();
    const {xtoken} = useParams();
    localStorage.setItem('@xtoken', xtoken);
    const [isChecked, setIsChecked] = useState(false);

    const dispatch = useDispatch();
    const handleAgreeChange = (event) => {
        setIsChecked(event.target.checked);
    };
    useEffect(() => {
        dispatch(fetchPlanosStart());
        dispatch(limparDadosEnvioPagamento())

    }, []);

    const handleSelecionar = (opcao) => {
        setOpcaoSelecionada(opcao.descricao)
        dispatch(fetchOpcoesStart(opcao));
    }

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const planoNormalizadoNome = `plano${planoNome?.toLowerCase().replace(/\s+/g, '')}`;
        const plano = planos.find(p => p.nome.replace(/\s+/g, '').toLowerCase() === planoNormalizadoNome);
        console.log(plano, planoNormalizadoNome, planos);
        if (planos.length > 0) {
            console.log(plano, planoNormalizadoNome, planos, 'pqp');
        }

        if (plano) {
            setPlanoSelecionado(plano);
            dispatch(setPlanoEscolhido(planoSelecionado));
        }
        setLoading(false);

    }, [planoNome, planos, dispatch, planoSelecionado, loading]);

    const slideIn = useSpring({
        from: { transform: 'translate3d(250%,0,0)' },
        to: { transform: 'translate3d(0,0,0)' },
        config: { tension: 170, friction: 26 },
    });

    const assinaturaID = planoID

    const handleConfirmarTroca = () => {
        dispatch(salvarPlano(assinaturaID))
        dispatch(consultarAssinatura({ usuarioID: usuarioID }))
        dispatch(setarFreemium(true))
        navigate(`/pagamento`);
    };

    const styledTypography = {
        marginBottom: 2,
        display: 'block',
        fontSize: { xs: '24px', md: '2rem' },
        fontWeight: '800',
        lineHeight: { xs: '28px', md: '2.375rem' },
        p: '0 10px',
    }
    const fadeIn = useSpring({ from: { opacity: -10 }, to: { opacity: 1 } });

    return (
        <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Grid
                maxWidth="md"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    minHeight: '60vh',
                    margin: '1rem 0',
                }}
                justifyContent={'center'}
            >
                <Box sx={{ textAlign: 'center' }}>
                    <Card
                        sx={{
                            mb: { xs: '1rem', md: '1rem' },
                            boxShadow: '0 0 0',
                        }}
                    >
                        <CardMedia
                            component={'img'}
                            sx={{
                                width: {
                                    xs: '40%',
                                    sm: '20%',
                                },
                                margin: '0 auto',
                            }}
                            image={logo}
                        />
                    </Card>
                    <Grid container spacing={2} >
                        <Typography variant='h5' color={'#000'} fontWeight={'600'} fontSize={'1.5rem'} my={'1rem'} width={'100%'}>
                            Selecione uma opção para o seu novo plano
                        </Typography>
                        <Grid item>
                            <Grid container spacing={'1rem'}>
                                {planoSelecionado.opcoes?.map((opcao, index) => (
                                    <Grid item xs={12} key={index}>
                                        <animated.div style={slideIn}>
                                            <Button
                                                variant={opcaoSelecionada === opcao.descricao ? 'contained' : 'outlined'}
                                                onClick={() => handleSelecionar(opcao)}
                                                sx={{
                                                    borderRadius: '10px',
                                                    borderColor: '#FF9F0D',
                                                    color: opcaoSelecionada === opcao.descricao ? 'white' : '#000',
                                                    backgroundColor: opcaoSelecionada === opcao.descricao ? '#FF9F0D' : 'white',
                                                    '&:hover': {
                                                        backgroundColor: opcaoSelecionada === opcao.descricao ? '#e68a00' : '#f5f5f5',
                                                        borderColor: '#e68a00',
                                                    },
                                                    height: '105px',
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: isMobile ? '0 10px' : '0 20px',
                                                    width: '100%',
                                                    position: 'relative',
                                                }}
                                            >
                                                {opcao.recomendado ? (
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-15px',
                                                            left: '50%',
                                                            transform: 'translateX(-50%)',
                                                            backgroundColor: 'white',
                                                            borderRadius: '20px',
                                                            padding: '3px 15px',
                                                            color: '#6a0dad',
                                                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        ECONOMIZE
                                                    </div>
                                                ) : null}
                                                {opcaoSelecionada === opcao.descricao ?
                                                    <CheckCircleIcon sx={{ fontSize: '2rem', mr: isMobile ? 0 : 2, color: '#fff' }} /> :
                                                    <RadioButtonUncheckedIcon sx={{ fontSize: '2rem', mr: 2 }} />
                                                }
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        position: isMobile ? 'static' : 'absolute',
                                                        zIndex: isMobile ? 0 : 1,
                                                        left: isMobile ? 'initial' : '50%',
                                                        transform: isMobile ? 'none' : 'translateX(-50%)',
                                                        textAlign: isMobile ? 'center' : 'initial',
                                                        width: isMobile ? 'initial' : 'initial',
                                                    }}
                                                >
                                                    {opcao.descricao}
                                                </Typography>

                                                <Box sx={{
                                                    textAlign: 'left',
                                                    ml: isMobile ? 0 : 1,
                                                    overflow: 'visible',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    width: isMobile ? '35%' : 'initial',
                                                }}>
                                                    <Typography variant="p" sx={{ display: 'block' }}>
                                                        {opcao.formasPagamento[0]?.numeroParcelas}x
                                                    </Typography>
                                                    <Typography variant="h5" fontWeight="bold" sx={{ lineHeight: 1 }}>
                                                        R$ {(Number(opcao.valor) / Number(opcao?.formasPagamento[0]?.numeroParcelas))?.toFixed(2).replace('.', ',')}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                                                        ou R${opcao.valor.toFixed(2).replace('.', ',')} PIX
                                                    </Typography>
                                                </Box>
                                            </Button>

                                        </animated.div>

                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>

                    </Grid>

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#FF9F0D',
                            '&:hover': { backgroundColor: '#e68a00' },
                            borderRadius: '10px',
                            p: '0.875rem',
                            width: { xs: '40%', md: '50%' },
                            fontSize: '1rem',
                            fontWeight: '800',
                            mt: '1rem',
                        }}
                        onClick={handleConfirmarTroca}
                    >
                        Confirmar
                    </Button>
                </Box>
            </Grid>
        </Container>
    );
}

export default TrocarPlano;
